import axiosPost from '../axiosPost';

export const cotizacionesDeMonedasDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "MonedaSerieDel",
        "params": {
            "monedaSerieId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}